<template>
  <div class="detail_information">
    <Flow v-bind:step="3"/>
    <div class="products_wrap bg_white mt12 pt16 pb16">
      <h2 class="content_title">お支払い方法</h2>
      <div class="payment_wrap mt24 c5a">
        <div v-for="(index, n) in paymentMethodList" class="payment_item bdb pl16 pr20 pb10" v-bind:class="{'pt19': n != 0}" :key="n">
          <div class="" :class="{ disable: paymentData.paymentMethod == 'WALLET'}">
            <input :id="'payment' + n" class="payment_radio" type="radio" name="payment" :checked="paymentData.paymentMethod == index.paymentMethod">
            <label :for="'payment' + n" class="payment_contents rb" v-on:click="selectPayment(index)">{{ index.paymentMethodName }}</label>
          </div>
          <div v-if="index.paymentMethod == 'CREDIT_CARD'" class="credit_label right_arrow" v-bind:class="{'select': paymentData.paymentMethod == 'CREDIT_CARD'}">
            <span v-if="creditData.cardNo" class="credit_number rr" v-on:click="selectCredit()">{{ creditData.cardNo }}</span>
            <span v-else class="credit_number rr" v-on:click="selectCredit()">クレジットカードが登録されていません</span>
          </div>
        </div>
        <div v-if="paymentData.paymentMethod == 'WALLET'" class="pl16 pt19 pr16 ab c5a">全額ウォレットで支払います</div>
      </div>

    </div>

    <!-- クレジット情報変更画面 -->
    <SelectCredit ref="openCreditSelect" v-bind:pageName="purchase" @close="closeCredit" />
    <ErrorModal v-show="isModalOpen" :errorMessage="errorMessage" @modalClose="modalClose" />
    <div class="products_wrap bg_white mt12 pt32 pb48">
      <a href="#" class="btn_blue" @click.stop.prevent="nextBtn()">次へ</a>
      <router-link class="btn_delete back_btn" :to="{ name: 'NSelectionDiscount' }">戻る</router-link>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import scrollPosition from '@/model/scrollPosition';
import ErrorModal from '@/components/common/ErrorModal'
import Flow from '@/components/n-selection/Flow'
import NSelection from '@/components/api/n-selection/n-selection';
import creditCard from '@/components/api/creditCard'
import SelectCredit from '@/components/n-selection/SelectCredit'


export default {
  components: {
    Flow,
    SelectCredit,
    ErrorModal,
  },
  data() {
    return {
      isModalOpen: false,
      errorMessage: '未選択の項目があります。',
      selectCreditOpen: false,
      purchase: 'nselection',
      paymentMethodList: [],
    }
  },
  methods: {
    selectPayment(data) {
      if(this.detailData.paymentData.paymentMethod == 'WALLET') return;
      this.$store.commit('nselection/setPaymentMethod', data.paymentMethod);
      this.$store.commit('nselection/setPaymentMethodName', data.paymentMethodName);
    },
    selectCredit() {
      scrollPosition.open();
      // SelectCreditコンポーネントの関数実行
      this.$refs.openCreditSelect.refsOpen();
    },
    closeCredit() {
      this.credit.open = false;
    },
    modalOpen() {
      // scrollPosition.open();
      this.isModalOpen = true;
    },
    modalClose() {
      // scrollPosition.close();
      this.isModalOpen = false;
    },
    nextBtn() {
      if(this.paymentData.paymentMethod == '') {
        this.errorMessage = 'お支払い方法を選択してください。';
        this.modalOpen();
        return;
      }
      if(this.paymentData.paymentMethod == 'CREDIT_CARD' && this.creditData.creditCardId == '') {
        this.errorMessage = 'クレジットカードを選択してください。';
        this.modalOpen();
        return;
      }
      /*
      TODO:paramsはstoreに保存でいい
      */
      this.$router.push({ name: 'NSelectionConfirm', params: {detailData: this.detailData}});
    },
    storeActionsPaymentData() {
      this.$store.dispatch('commitUserDetailPaymentData', { paymentMethodId: '', paymentMethodName: this.detailData.paymentData.paymentMethodName, paymentMethod: this.detailData.paymentData.paymentMethod });
    },
    async apiGetPaymentMethodList () {
      await NSelection.getPaymentMethodList().then((val) => {
        console.log('getPaymentMethodList');
        console.log(val);
        this.paymentMethodList.push(...val);
        // ウォレット使用後の請求金額が0の場合
        if(this.useWalletBillAmount == 0 || this.useWalletBillAmount < 0) {
          this.$store.commit('nselection/setPaymentMethod', 'WALLET');
          this.$store.commit('nselection/setPaymentMethodName', '全額ウォレット支払い');
        } else {
          this.$store.commit('nselection/setPaymentMethod', val[0].paymentMethod);
          this.$store.commit('nselection/setPaymentMethodName', val[0].paymentMethodName);
        }
      });
    },
    initialized() {
      this.paymentMethodList.splice(0, this.paymentMethodList.length);
      this.$store.commit('nselection/setPaymentMethod', '');
      this.$store.commit('nselection/setPaymentMethodName', '');
    },
  },
  computed: mapGetters(
    'nselection', [
      'detailData',
      'paymentData',
      'creditData',
      'walletAmount',
      'shipmentFee',
      'useWalletBillAmount',
    ]
  ),
  created () {
    this.initialized();
    this.apiGetPaymentMethodList();
  },
}
</script>

<style lang="css" scoped>
.content_title {
  width: 123px;
}
.shipping_time, .coupon_select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.shipping_time {
  border: none;
  font-size: 16px;
  position: relative;
  width: 100%;
  z-index: 1;
}

.detail_information .address {
  font-size: 14px;
  margin-top: 3px;
}
.address_text {
  margin-left: 8px;
}

.credit_number {
  display: block;
  font-size: 14px;
}

.credit_label {
  display: none;
  margin-top: 15px;
  padding-left: 28px;
}

.credit_label.select {
  display: block;
}

.no_coupon {
  margin-bottom: 24px;
  padding-bottom: 5px;
}

.coupon_title {
  border-left: 4px solid  #4FCCD4;
  font-size: 16px;
  padding-left: 4px;
}

.coupon_item {
  align-items: flex-end;
  display: flex;
  margin-top: 27px;
}
.possession_coupon {
  display: flex;
  width: 68%;
}

.possession_count, .can_count {
  font-size: 12px;
}
.possession_count--number, .can_count--number {
  font-size: 18px;
  margin-left: 9px;
}

.can_count {
  margin-left: 26px;
}

.use_wrap {
  align-items: center;
  display: flex;
  margin-left: 8px;
  width: 30%;
}
.use_text {
  font-size: 12px;
  min-width: 40px;
}

.coupon_select--wrap {
  width: 60%;
}

.coupon_select {
  border: none;
  border-bottom: 1px solid  #5a5a5a;
  font-size: 26px;
  padding-left: 15px;
  width: 100%;
}



.coupon_select--wrap.bottom_arrow::after {
  bottom: 7px;
  right: 2px;
}

.select_wrap.bottom_arrow::after {
  bottom: 7px;
  right: 22px;
}

.payment_item .right_arrow::after {
  right: 5px;
}

.disable {
  position: relative;
}
.disable::before {
  background-color: #aaa;
  content: '';
  height: 100%;
  left: 0;
  opacity: .5;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 4;
}
</style>



// WEBPACK FOOTER //
// src/views/n-selection/DetailInformation.vue